/* eslint-disable no-param-reassign */
import { action, thunk } from 'easy-peasy';
import { fetchPantryPrograms } from '../../services/fbm-api';

export default {
  data: null,
  loading: false,
  fetch: thunk(async (actions, pantryPath, { getStoreActions }) => {
    try {
      actions.setLoading(true);
      const response = await fetchPantryPrograms(pantryPath);
      actions.set(response);
    } catch ({ message }) {
      getStoreActions().notifications.showError({ message });
    } finally {
      actions.setLoading(false);
    }
  }),
  set: action((state, { items }) => {
    state.data = items;
  }),
  clear: action(state => {
    state.data = null;
  }),
  setLoading: action((state, loading) => {
    state.loading = loading;
  })
};
